import React from 'react';
import Navbar from '../../Navbar.jsx';
import Sidebar from '../Sidebar.jsx';
import RightNav from '../RightNav.jsx';
import Seo from '../../Seo';
import DocPager from './docpager';
import '../../../pages/docs/DirectWebIntegration.css';
import './wq-integration.css';

/**
 * Shared frame for the developer docs pages: Seo, navbar, sidebar, hero,
 * footer, Previous/Next cards and the right-hand contents. Matches the layout
 * of the Standard API Integration page, so every docs page looks the same.
 *
 * `contents` must list the id of each <section> in order — RightNav links to them.
 */
function DocPage({ seo, eyebrow, title, contents, footer, prev, next, children }) {
    return (
        <div className="wq-root">
            <Seo title={seo.title} description={seo.description} />
            <Navbar />
            <div className="w-full flex">
                <Sidebar />
                <div className="documentation-container px-8 py-4 flex items-start">
                    <div className="content">
                        <section className="wq-hero">
                            {eyebrow && <div className="wq-hero-eyebrow">{eyebrow}</div>}
                            <h1 className="wq-h1">{title}</h1>
                        </section>

                        {children}

                        {footer && (
                            <footer className="wq-footer">
                                <p>{footer}</p>
                            </footer>
                        )}

                        <DocPager prev={prev} next={next} />
                    </div>
                    <RightNav contents={contents} />
                </div>
            </div>
        </div>
    );
}

export default DocPage;